// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1Zk0_","title":"BackImages_title__2RY_J","images":"BackImages_images__288hO"};